'use client';

import { useContext } from 'react';

import { ColorModeContext } from '../contexts';

import type { ColorModeContextState } from '../contexts';

export const useDarkModeContext = (): ColorModeContextState => useContext( ColorModeContext );
